import Chart from 'chart.js'

export default class FumDistributionBarSmallChart {
  constructor () {
    var ctx = document
      .getElementById('fum-distribution-bar-small')
      .getContext('2d')
    this.chartBarSmall = new Chart(ctx, {
      type: 'horizontalBar',
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              'rgba(42, 10, 78, 1)',
              'rgba(62, 34, 95, 1)',
              'rgba(84, 59, 113, 1)',
              'rgba(105, 83, 130, 1)',
              'rgba(127, 108, 148, 1)',
              'rgba(148, 132, 166, 1)',
              'rgba(169, 157, 184, 1)',
              'rgba(191, 181, 202, 1)',
              'rgba(212, 206, 219, 1)',
              'rgba(234, 230, 237, 1)'
            ],
            hoverBorderColor: [
              'rgba(42, 10, 78, 1)',
              'rgba(62, 34, 95, 1)',
              'rgba(84, 59, 113, 1)',
              'rgba(105, 83, 130, 1)',
              'rgba(127, 108, 148, 1)',
              'rgba(148, 132, 166, 1)',
              'rgba(169, 157, 184, 1)',
              'rgba(191, 181, 202, 1)',
              'rgba(212, 206, 219, 1)',
              'rgba(234, 230, 237, 1)'
            ],
            hoverBorderWidth: 1
          }
        ]
      },
      options: {
        legend: { display: false },
        tooltips: { enabled: false },
        scales: {
          yAxes: [
            {
              barThickness: 5,
              gridLines: {
                color: 'rgba(0,0,0,1)',
                display: true,
                drawBorder: false,
                offsetGridLines: false
              },
              position: 'right',
              ticks: {
                display: false,
                fontFamily: "'heldane-text-regular','serif'",
                fontSize: 14,
                fontColor: '#000',
                padding: 10,
                callback: ticksCallback
              }
            }
          ],
          xAxes: [
            { gridLines: { display: false, drawBorder: false }, display: false }
          ]
        },
        maintainAspectRatio: false
      }
    })
  }

  updateFumDistributionBarSmallData (data) {
    data.sort((a, b) => {
      return parseFloat(Object.values(b)[0]) - parseFloat(Object.values(a)[0])
    })
    const labels = data.map(x => Object.keys(x))
    const dataset = data.map(x => Object.values(x))

    const chart = document.querySelector('.bar-small-chart-container')
    const chartCanvas = document.getElementById('fum-distribution-bar-small')
    let chartHeight = dataset.length * 20
    chart.style.height = chartHeight + 'px'
    chartCanvas.style.height = chartHeight + 'px'

    this.chartBarSmall.data.labels = labels
    this.chartBarSmall.data.datasets[0].data = Object.values(dataset)
    this.chartBarSmall.update()

    const ticks = document.querySelector('.bar-small__ticks')

    data.map(x => {
      const tick = document.createElement('div')
      tick.classList.add('bar-small__ticks--item')
      tick.innerHTML = Object.keys(x)
      ticks.appendChild(tick)
    })
  }
}

const ticksCallback = (value, index, values) => {
  return ''
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/fum_distribution_bar_small.js